import React, { useState } from 'react'
import { useQuery, useMutation, useQueryClient } from 'react-query'
import { apiService } from '../../services/api'
import toast from 'react-hot-toast'
import LoadingSpinner from '../common/LoadingSpinner'
import '../../styles/admin-pages.css'

// ── SVG icons ─────────────────────────────────────────────────────────────────
function IconGlobe({ size = 16 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10" /><line x1="2" y1="12" x2="22" y2="12" />
      <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
    </svg>
  )
}
function IconShield({ size = 16 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
    </svg>
  )
}
function IconClock({ size = 16 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10" /><polyline points="12 6 12 12 16 14" />
    </svg>
  )
}
function IconCloud({ size = 16 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M18 10h-1.26A8 8 0 1 0 9 20h9a5 5 0 0 0 0-10z" />
    </svg>
  )
}
function IconSearch({ size = 15 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="11" cy="11" r="8" /><line x1="21" y1="21" x2="16.65" y2="16.65" />
    </svg>
  )
}
function IconPlus({ size = 14 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <line x1="12" y1="5" x2="12" y2="19" /><line x1="5" y1="12" x2="19" y2="12" />
    </svg>
  )
}
function IconCopy({ size = 13 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="9" y="9" width="13" height="13" rx="2" /><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
    </svg>
  )
}
function IconTrash({ size = 13 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="3 6 5 6 21 6" /><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" />
      <path d="M10 11v6" /><path d="M14 11v6" /><path d="M9 6V4h6v2" />
    </svg>
  )
}
function IconSettings({ size = 13 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="3" />
      <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z" />
    </svg>
  )
}
function IconCheck({ size = 13 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="20 6 9 17 4 12" />
    </svg>
  )
}

// ── Helpers ───────────────────────────────────────────────────────────────────
const getDisplayDomain = (domain) => domain?.startsWith('www.') ? domain.substring(4) : domain

const getStatusText = (status) => {
  switch (status) {
    case 'verified':       return 'Verified'
    case 'active':         return 'Active'
    case 'pending':        return 'Pending'
    case 'dns_configured': return 'DNS OK'
    case 'failed':         return 'Failed'
    default:               return status || 'Unknown'
  }
}

// ── Toggle Switch ─────────────────────────────────────────────────────────────
function ToggleSwitch({ checked, onChange }) {
  return (
    <label className="toggle-switch">
      <input type="checkbox" checked={checked} onChange={e => onChange(e.target.checked)} />
      <span className="toggle-track" />
    </label>
  )
}

// ── SSL Badge ─────────────────────────────────────────────────────────────────
function SslBadge({ domain }) {
  const ssl = domain.ssl_enabled || domain.verification_method === 'none'
  const sslStatus = domain.ssl_status || (ssl ? 'valid' : 'missing')

  if (sslStatus === 'provisioning' || domain.ssl_status === 'provisioning') {
    return <span className="ssl-badge provisioning"><IconCloud size={12} /> Provisioning</span>
  }
  if (!ssl && sslStatus !== 'valid') {
    return <span className="ssl-badge missing"><IconShield size={12} /> No SSL</span>
  }
  return <span className="ssl-badge valid"><IconShield size={12} /> Valid SSL</span>
}

// ── DNS Records Card ──────────────────────────────────────────────────────────
function DnsRecordsCard({ domain }) {
  const fullDomain = domain.subdomain ? `${domain.subdomain}.${domain.domain}` : domain.domain
  const records = domain.dns_records || [
    { type: 'A',     name: '@',          value: '76.76.21.21',         ttl: 'auto', ok: true },
    { type: 'A',     name: '@',          value: '76.76.21.22',         ttl: 'auto', ok: true },
    { type: 'CNAME', name: 'www',        value: 'cname.webnest.app',   ttl: 'auto', ok: false },
    { type: 'TXT',   name: '_webnest',   value: 'verify=8x3kf-2092…',  ttl: 'auto', ok: false },
  ]

  return (
    <div className="dns-records-card">
      <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', marginBottom: 14, flexWrap: 'wrap', gap: 8 }}>
        <div>
          <h3 style={{ margin: 0, fontSize: 14, fontWeight: 600, color: 'var(--text)' }}>DNS records · {fullDomain}</h3>
          <p style={{ margin: '3px 0 0', fontSize: 12, color: 'var(--text-muted)' }}>Add these records at your registrar to complete verification</p>
        </div>
        <span className="status-pill pending">Awaiting verification</span>
      </div>
      <div style={{ overflowX: 'auto' }}>
        <table className="domains-table" style={{ background: 'var(--bg-0)' }}>
          <thead>
            <tr>
              <th style={{ width: 60 }}>Type</th>
              <th style={{ width: 100 }}>Name</th>
              <th>Value</th>
              <th style={{ width: 60 }}>TTL</th>
              <th style={{ width: 110 }}>Status</th>
              <th style={{ width: 60 }}></th>
            </tr>
          </thead>
          <tbody>
            {records.map((r, i) => (
              <tr key={i}>
                <td><span style={{ fontFamily: 'var(--font-mono)', fontSize: 11, background: 'var(--border)', borderRadius: 5, padding: '2px 7px', fontWeight: 600 }}>{r.type}</span></td>
                <td style={{ fontFamily: 'var(--font-mono)', fontSize: 12 }}>{r.name}</td>
                <td style={{ fontFamily: 'var(--font-mono)', fontSize: 11.5, color: 'var(--text-muted)', maxWidth: 260, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{r.value}</td>
                <td style={{ fontFamily: 'var(--font-mono)', fontSize: 12, color: 'var(--text-faint)' }}>{r.ttl}</td>
                <td>
                  {r.ok
                    ? <span className="status-pill active" style={{ fontSize: 11 }}><IconCheck size={11} /> Detected</span>
                    : <span className="status-pill pending" style={{ fontSize: 11 }}>Awaiting</span>
                  }
                </td>
                <td>
                  <button
                    className="copy-btn"
                    onClick={() => { navigator.clipboard?.writeText(r.value); toast.success('Copied!') }}
                  >
                    <IconCopy size={11} /> Copy
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}

// ── Main Component ────────────────────────────────────────────────────────────
const DomainDashboard = () => {
  const [searchTerm, setSearchTerm] = useState('')
  const [statusFilter, setStatusFilter] = useState('all')
  const [selectedDomain, setSelectedDomain] = useState(null)
  const [isRefreshing, setIsRefreshing] = useState(false)
  const queryClient = useQueryClient()

  // ── Queries & Mutations (preserve all original) ────────────────────────────
  const { data: domainsData, isLoading, error, refetch } = useQuery(
    'admin-domains',
    () => apiService.get('/domains').then(res => res.data),
    { staleTime: 30000, refetchInterval: 60000 }
  )

  const handleRefresh = async () => {
    setIsRefreshing(true)
    setTimeout(() => setIsRefreshing(false), 1000)
    try { await refetch() } catch (err) { /* silent */ }
  }

  const verifyDomainMutation = useMutation(
    (domainId) => apiService.post(`/domains/${domainId}/verify`),
    {
      onSuccess: (data) => {
        if (data.data.message && data.data.domain) toast.success(data.data.message)
        else toast.error('Verification response was incomplete')
        queryClient.invalidateQueries('admin-domains')
      },
      onError: (error) => toast.error(error.response?.data?.error || 'Verification failed')
    }
  )

  const deleteDomainMutation = useMutation(
    (domainId) => apiService.delete(`/domains/${domainId}`),
    {
      onSuccess: () => {
        toast.success('Domain deleted successfully!')
        queryClient.invalidateQueries('admin-domains')
        if (selectedDomain?.id === deleteDomainMutation.variables) setSelectedDomain(null)
      },
      onError: (error) => toast.error(error.response?.data?.error || 'Failed to delete domain')
    }
  )

  const updateDomainMutation = useMutation(
    ({ domainId, settings }) => apiService.patch(`/domains/${domainId}`, settings),
    {
      onSuccess: () => {
        toast.success('Domain settings updated!')
        queryClient.invalidateQueries('admin-domains')
      },
      onError: (error) => toast.error(error.response?.data?.error || 'Failed to update domain settings')
    }
  )

  const domains = domainsData?.domains || []

  const filteredDomains = domains.filter(domain => {
    const fullDomainName = domain.subdomain ? `${domain.subdomain}.${domain.domain}` : domain.domain
    const matchesSearch =
      searchTerm === '' ||
      fullDomainName.toLowerCase().includes(searchTerm.toLowerCase()) ||
      domain.company_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      domain.contact_email?.toLowerCase().includes(searchTerm.toLowerCase())
    const matchesStatus = statusFilter === 'all' || domain.status === statusFilter
    return matchesSearch && matchesStatus
  })

  const stats = {
    total:    domains.length,
    active:   domains.filter(d => d.status === 'verified' || d.status === 'active').length,
    expiring: domains.filter(d => d.ssl_expiry_days && d.ssl_expiry_days < 30).length,
    pending:  domains.filter(d => d.status === 'pending').length,
  }

  const pendingDomains = filteredDomains.filter(d => d.status === 'pending' || d.status === 'dns_configured')

  if (isLoading) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: 240 }}>
        <LoadingSpinner size="lg" text="Loading domains..." />
      </div>
    )
  }

  if (error) {
    return (
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: 240, gap: 12, color: 'var(--text-muted)' }}>
        <p style={{ fontSize: 13 }}>Failed to load domains.</p>
        <button className="ds-btn ds-btn-ghost" onClick={() => refetch()}>Retry</button>
      </div>
    )
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 18, paddingTop: 4 }}>

      {/* ── Header ─── */}
      <div className="page-header">
        <div className="page-title">
          <div className="eyebrow">Workspace · Domains</div>
          <h1>Domains</h1>
          <div className="subtitle">{stats.total} connected · {stats.active} active · {stats.pending} pending · {stats.expiring} SSL expiring soon</div>
        </div>
        <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
          <button
            className="ds-btn ds-btn-ghost"
            onClick={handleRefresh}
            disabled={isRefreshing}
            style={{ display: 'flex', alignItems: 'center', gap: 6 }}
          >
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
              style={isRefreshing ? { animation: 'spin 1s linear infinite' } : {}}>
              <path d="M21.5 2v6h-6" /><path d="M2.5 12a10 10 0 0 1 17.8-5.5l1.2 1" />
              <path d="M2.5 22v-6h6" /><path d="M21.5 12a10 10 0 0 1-17.8 5.5l-1.2-1" />
            </svg>
            Refresh
          </button>
          <button className="ds-btn ds-btn-ghost" style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
            <IconPlus size={14} /> Connect domain
          </button>
        </div>
      </div>

      {/* ── Mini stats ─── */}
      <div className="domain-stats-row">
        {[
          { label: 'Total Domains', value: stats.total, icon: <IconGlobe size={18} />, color: '#e0e7ff', iconColor: '#4338ca' },
          { label: 'SSL Active',    value: stats.active,   icon: <IconShield size={18} />, color: '#dcfce7', iconColor: '#15803d' },
          { label: 'Expiring Soon', value: stats.expiring, icon: <IconClock size={18} />, color: '#fef3c7', iconColor: '#b45309' },
          { label: 'Pending DNS',   value: stats.pending,  icon: <IconCloud size={18} />, color: '#dbeafe', iconColor: '#1d4ed8' },
        ].map((s, i) => (
          <div key={i} className="domain-stat-chip">
            <div className="domain-stat-icon" style={{ background: s.color }}>
              <span style={{ color: s.iconColor }}>{s.icon}</span>
            </div>
            <div>
              <div className="domain-stat-label">{s.label}</div>
              <div className="domain-stat-value">{s.value}</div>
            </div>
          </div>
        ))}
      </div>

      {/* ── Filter bar ─── */}
      <div className="filter-bar">
        <span style={{ color: 'var(--text-faint)' }}><IconSearch size={15} /></span>
        <input
          className="input"
          placeholder="Search domains, clients…"
          value={searchTerm}
          onChange={e => setSearchTerm(e.target.value)}
          style={{ flex: 1 }}
        />
        <div className="vdiv" style={{ height: 20 }} />
        <div className="segmented">
          {[['all','All'],['active','Active'],['verified','Verified'],['pending','Pending'],['failed','Failed']].map(([v,l]) => (
            <button key={v} className={statusFilter === v ? 'on' : ''} onClick={() => setStatusFilter(v)}>{l}</button>
          ))}
        </div>
      </div>

      {/* ── Domains table ─── */}
      <div className="domains-table-wrap">
        <table className="domains-table">
          <thead>
            <tr>
              <th>Domain</th>
              <th>Client</th>
              <th>Status</th>
              <th>SSL</th>
              <th>Expiry</th>
              <th>Auto-renew</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {filteredDomains.length === 0 ? (
              <tr>
                <td colSpan={7} style={{ textAlign: 'center', padding: '32px 0', color: 'var(--text-faint)', fontSize: 13 }}>
                  No domains match your filters
                </td>
              </tr>
            ) : filteredDomains.map((domain) => {
              const fullName = domain.subdomain ? `${domain.subdomain}.${domain.domain}` : domain.domain
              const displayName = getDisplayDomain(fullName)
              const statusText = getStatusText(domain.status)
              const statusKey = (['active','verified'].includes(domain.status)) ? 'active' : domain.status

              return (
                <tr key={domain.id} style={{ cursor: 'pointer' }} onClick={() => setSelectedDomain(selectedDomain?.id === domain.id ? null : domain)}>
                  <td>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                      <span style={{ color: 'var(--accent)' }}><IconGlobe size={14} /></span>
                      <span style={{ fontWeight: 600, fontFamily: 'var(--font-mono)', fontSize: 13 }}>{displayName}</span>
                    </div>
                    {fullName !== displayName && (
                      <div style={{ fontSize: 11, color: 'var(--text-faint)', marginTop: 2, fontFamily: 'var(--font-mono)' }}>→ {fullName}</div>
                    )}
                  </td>
                  <td style={{ fontSize: 12.5, color: 'var(--text-muted)' }}>{domain.company_name || '—'}</td>
                  <td><span className={`status-pill ${statusKey}`}>{statusText}</span></td>
                  <td><SslBadge domain={domain} /></td>
                  <td style={{ fontFamily: 'var(--font-mono)', fontSize: 12, color: 'var(--text-muted)' }}>
                    {domain.expiry_date ? new Date(domain.expiry_date).toLocaleDateString('en', { month: 'short', day: 'numeric', year: 'numeric' }) : '—'}
                  </td>
                  <td onClick={e => e.stopPropagation()}>
                    <ToggleSwitch
                      checked={!!domain.auto_renew}
                      onChange={(val) => updateDomainMutation.mutate({ domainId: domain.id, settings: { auto_renew: val } })}
                    />
                  </td>
                  <td onClick={e => e.stopPropagation()}>
                    <div style={{ display: 'flex', gap: 4 }}>
                      {(domain.status === 'pending' || domain.status === 'dns_configured') && (
                        <button
                          className="tbl-action-btn"
                          title="Verify DNS"
                          onClick={() => verifyDomainMutation.mutate(domain.id)}
                          disabled={verifyDomainMutation.isLoading}
                          style={{ display: 'flex', alignItems: 'center', gap: 4 }}
                        >
                          <IconSettings size={12} /> DNS
                        </button>
                      )}
                      <button
                        className="tbl-action-btn danger"
                        title="Delete domain"
                        onClick={() => { if (window.confirm(`Delete ${displayName}?`)) deleteDomainMutation.mutate(domain.id) }}
                        disabled={deleteDomainMutation.isLoading}
                        style={{ display: 'flex', alignItems: 'center', gap: 4 }}
                      >
                        <IconTrash size={12} />
                      </button>
                    </div>
                  </td>
                </tr>
              )
            })}
          </tbody>
        </table>
      </div>

      {/* ── DNS Records card for pending domains ─── */}
      {pendingDomains.length > 0 && (
        <DnsRecordsCard domain={pendingDomains[0]} />
      )}

      {/* ── Selected domain DNS detail ─── */}
      {selectedDomain && (selectedDomain.status === 'pending' || selectedDomain.status === 'dns_configured') && (
        <DnsRecordsCard domain={selectedDomain} />
      )}

    </div>
  )
}

export default DomainDashboard
